import { FeedbackForm } from '@/components/FeedbackForm';
import { useTheme } from '@/hooks/useTheme';

function App() {
  useTheme();

  return (
    <div className="min-h-screen bg-background text-foreground">
      <div className="container mx-auto p-4 py-8">
        <FeedbackForm />
      </div>
    </div>
  );
}

export default App;
